import { BaseMutations } from '@/store/base-mutations';
import ReturnZipsState from './state';
import { Repairs } from '../../../types';

export default class ReturnZipsMutations extends BaseMutations<ReturnZipsState> {
  TOGGLE_LOADING_RETURN_ZIPS(toggle: boolean) {
    this.state.return_zips_loading = toggle;
  }

  SET_RETURN_ZIPS_LIST(items: Repairs.ReturnZip[]) {
    this.state.return_zips_list = items;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof Repairs.ReturnZipsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  SET_TRANSPORT_COMPANIES(items: Repairs.TransportCompany[]) {
    this.state.transport_companies = items;
  }
}
